var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',_vm._b({staticStyle:{"z-index":"1"}},'v-app-bar',Object.assign({}, _vm.defaultAttrs, _vm.$attrs),false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }